if (!customElements.get('count-down')) {
  customElements.define('count-down', class Countdown extends HTMLElement {
    constructor() {
      super();

      this.endDate = this.getAttribute('end-date') || '';
      this.timeElement = this.querySelector('time');
      this.id_for = this.dataset.timerFor;
      this.init();
    }

    disconnectedCallback() {
      clearInterval(this.timeInterval);
    }

    init () {
      this.target = Date.parse(this.endDate);

      // An unparseable or missing end date must not be rendered as a row of
      // zeroes — that reads as "offer over" to a shopper. Leave the markup's
      // placeholder in place and say why in the console instead.
      if (!Number.isFinite(this.target)) {
        console.warn('[count-down] Unusable end-date attribute:', JSON.stringify(this.endDate));
        return;
      }

      const countdownTime = this.getCountdownTime();

      if (countdownTime.total > 0) {
        this.renderCountdown(countdownTime);
        this.timeInterval = setInterval(() => {
          this.renderCountdown(this.getCountdownTime());
        }, 1000);
      } else {
        this.renderCountdown(countdownTime);
        this.markEnded();
      }
    }

    getCountdownTime() {
      const total = Math.max(0, this.target - Date.now());

      return {
        total,
        days: Math.floor(total / 86400000),
        hours: Math.floor(total / 3600000) % 24,
        minutes: Math.floor(total / 60000) % 60,
        seconds: Math.floor(total / 1000) % 60,
      };
    }

    renderCountdown(countdownTime) {
      const pad = (value) => String(value).padStart(2, '0');

      const daysElement = this.querySelector('.days');
      const hoursElement = this.querySelector('.hours');
      const minutesElement = this.querySelector('.minutes');
      const secondsElement = this.querySelector('.seconds');

      if (daysElement) daysElement.textContent = pad(countdownTime.days);
      if (hoursElement) hoursElement.textContent = pad(countdownTime.hours);
      if (minutesElement) minutesElement.textContent = pad(countdownTime.minutes);
      if (secondsElement) secondsElement.textContent = pad(countdownTime.seconds);

      if (this.timeElement) {
        this.timeElement.setAttribute('datetime', `P${countdownTime.days}DT${countdownTime.hours}H${countdownTime.minutes}M${countdownTime.seconds}S`);
      }

      if (countdownTime.total <= 0) {
        clearInterval(this.timeInterval);
        this.markEnded();
      }
    }

    markEnded() {
      if (this.hasAttribute('data-ended')) return;
      this.setAttribute('data-ended', 'true');
      document.dispatchEvent(new CustomEvent(`countdownEnded-${this.id_for}`));
    }
  });
}
